export default __webpack_public_path__ + "static/media/ct-2.e9b304ff.png";